import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconDone from '@/icons/Done.svg';
import { useGetArticleName } from '@/models/article';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const ArticleExchangeConfirmedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'article_exchange_confirmed'>;
}) => {
  const { request } = useRequestContext();
  const getArticleName = useGetArticleName();

  const workshopName = activity.entity.name;
  const creatorName = activity.creator?.name;

  const exchangedToArticle = request?.allArticles.find(
    (article) => article.id === activity.data.exchangedToId
  );

  const exchangedFromName = getArticleName({ article: activity.article });
  const exchangedToName = getArticleName({ article: exchangedToArticle });

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconDone />}
      message={
        <BaseActivityText>
          {activity.data.onBehalfOfWorkshop ? (
            <Trans id="activities.article_exchange_confirmed.message.on-behalf">
              <strong>{creatorName}</strong> validated the exchange of the original item{' '}
              {exchangedFromName} with the replacement item {exchangedToName} on behalf of{' '}
              <strong>{workshopName}</strong>
            </Trans>
          ) : (
            <Trans id="activities.article_exchange_confirmed.message">
              <strong>{creatorName}</strong> validated the exchange of the original item{' '}
              {exchangedFromName} with the replacement item {exchangedToName}
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
